import { styled } from "styled-components";

import { MarkdownArea } from "common/components";
import { useTranslate } from "common/utilities/useTranslate";
import type { CustomKnowledge } from "domains/customContentAndSources/types";
import { KnowledgeButtons } from "domains/publication/components/KnowledgeButtons";
import type { Knowledge } from "entities/knowledge/types";

const StyledTextContent = styled.div`
  padding-top: 10px;
`;

const StyledDescriptionContainer = styled.div`
  padding-top: 10px;
  width: 100%;
  border-top: ${({ theme }) => theme.borders.normal};
`;

const StyledDescription = styled.div`
  margin: 0;
  line-height: 1.2rem;
`;

const StyledButtonRow = styled.div`
  margin-top: 10px;
`;

type PublicationCardBodyProps = { knowledge: Knowledge | CustomKnowledge; link: string };

export const PublicationCardBody = ({ knowledge, link }: PublicationCardBodyProps) => {
  const translate = useTranslate();
  const { summary } = knowledge;

  return (
    <StyledTextContent>
      <StyledDescriptionContainer>
        <StyledDescription>
          <MarkdownArea>{summary || translate("app.discover.topic.summary.no_description")}</MarkdownArea>
        </StyledDescription>
      </StyledDescriptionContainer>
      {link && (
        <StyledButtonRow>
          <KnowledgeButtons knowledge={knowledge} shareLink={link} fullwidth />
        </StyledButtonRow>
      )}
    </StyledTextContent>
  );
};
